@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";
@mixin border {
  border-radius: 20px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
}

@mixin card {
  @include border;
  background-color: var(--white);
  max-width: var(--max-desktop-width);
  flex-grow: 1;
  margin: 18px var(--card-gutter-width);
}

.card {
  @include card;
}

.introduction {
  padding: 16px 24px;
  text-align: center;
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--brand-indigo);

  @include breakpoints.desktop {
    padding: 24px 32px;
  }
}

.header {
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--brand-indigo);
  margin: 0 0 4px;
}

.headerV3 {
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--brand-indigo);
  margin: 0 0 24px;
}

.subheading{
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--brand-indigo);
}

.subheadingV3 {
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--brand-indigo);
  margin: 0 0 20px;
}

.pageDivider {
  width: 100vw;
  margin: 0 0 24px calc(50% - 50vw);
  height: 1px;
  @include breakpoints.desktop {
    background-color: var(--gray-06);
  }
}

.content {
  padding: 24px 24px 0;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.contentNew {
  padding: 24px 24px 0;
  background:white;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.addressFieldGroup {
  @include breakpoints.mobile-large {
    display: grid;
    grid-gap: 0 16px;
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
  margin: 0px;
}

.alwaysVisible {
  display: inherit;
}

.field {
  margin: 0 0 16px;
}

.apt {
  margin: 3px 0 16px;
}

.fieldSpan {
  grid-column: 1 / span 2;
}

.FieldLegend {
  position: initial;
  width: 100%;
  text-align: initial;
  margin-bottom: 12px;
}

.sexCustom {
  color: var(--brand-indigo);
  font-family: typography.$font-mont;
  font-size: 14px;
  @include breakpoints.desktop {
    font-size: 16px;
  }
}

.sexFieldGroup {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  font-family: typography.$font-mont;
  font-size: 14px;

  @include breakpoints.desktop {
    margin: 0;
    font-size: 16px;
  }
}

.buttonGroup {
  margin: 12px 0 16px;
}

.radioButton {
  margin-bottom: 16px;
}

.emptyError {
  display: none;
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin-bottom: 24px;
  font-family: typography.$font-mont;

  @include breakpoints.desktop {
    margin: {
      top: 0;
      bottom: 24px;
    }
  }
}

.toggle {
  margin-bottom: 16px;

  @include breakpoints.desktop {
    margin-top: 28px;
  }
}

.accommodationField {
  margin-top: 24px;
}

.contentBG {
  background: var(--gray-05);
}
